import { render, staticRenderFns } from "./IrrRequestFormComponent.vue?vue&type=template&id=359f0460"
import script from "./IrrRequestFormComponent.vue?vue&type=script&lang=js"
export * from "./IrrRequestFormComponent.vue?vue&type=script&lang=js"
import style0 from "./IrrRequestFormComponent.vue?vue&type=style&index=0&id=359f0460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports